import api from '@/api';
import { API_BASE_URL } from '..';
import {
  StoneDevice,
  StoneDeviceCreateRequest,
  StoneDeviceListRequest,
  StoneDeviceRemoveRequest,
  StoneDeviceUpdateRequest,
} from './devices.types';

const CONTROLLER = `${API_BASE_URL}/devices`;

export default {
  async list(params: StoneDeviceListRequest) {
    const result = (await api.get(CONTROLLER, params)) as unknown;
    return result as StoneDevice[];
  },

  async create(data: StoneDeviceCreateRequest) {
    const result = (await api.post(CONTROLLER, data, null)) as unknown;
    return result as StoneDevice;
  },

  async update({ deviceId, ...data }: StoneDeviceUpdateRequest) {
    const result = (await api.put(
      `${CONTROLLER}/${deviceId}`,
      data,
      null,
    )) as unknown;
    return result as StoneDevice;
  },

  async remove({ deviceId }: StoneDeviceRemoveRequest) {
    const result = (await api.remove(
      `${CONTROLLER}/${deviceId}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },
};
